<template>
  <div class="tw-fixed tw-inset-0 tw-flex tw-items-end tw-justify-center tw-px-2 tw-py-6 tw-pointer-events-none sm:tw-p-6 sm:tw-items-end sm:tw-justify-end tw-z-50">
    <div class="tw-max-w-sm tw-w-full">
      <transition-group
        tag="div"
        :enter-active-class="`tw-transform tw-ease-out tw-duration-300 tw-transition ${sortedNotifications.length > 1 ? 'tw-delay-300' : ''}`"
        enter-class="tw-translate-y-2 tw-opacity-0 sm:tw-translate-y-0 sm:tw-translate-x-2"
        enter-to-class="tw-translate-y-0 tw-opacity-100 sm:tw-translate-x-0"
        leave-active-class="tw-transition tw-ease-in tw-duration-200"
        leave-class="tw-opacity-100"
        leave-to-class="tw-opacity-0"
        move-class="tw-transition tw-ease-in-out tw-duration-500"
      >
        <notification
          v-for="(notification, index) in sortedNotifications"
          :key="notification.id"
          :id="notification.id"
          :title="notification.title"
          :message="notification.message"
          :is-error="notification.isError"
          :class="{ 'tw-mt-4': index }"
          @remove="remove(notification.id)"
        />
      </transition-group>
    </div>
  </div>
</template>

<script>
import Notification from "@/components/v2/Notification";

export default {
  components: {
    Notification,
  },
  data() {
    return {
      count: 0,
      notifications: [],
    };
  },
  computed: {
    sortedNotifications() {
      return [...this.notifications].slice(0, 4);
    },
  },
  created() {
    this.EventBus.$on("GLOBAL_NOTIFY", this.showNotification);
  },
  methods: {
    showNotification(payload) {
      const notification = {
        id: this.count++,
        title: payload.title,
        message: payload.message,
        isError: !!payload.isError,
      };
      this.notifications.push(notification);
      setTimeout(() => this.remove(notification.id), 4000);
    },
    remove(id) {
      this.notifications = this.notifications.filter((n) => n.id !== id);
    },
  },
};
</script>
